import {basicContext} from "../../../utils/contextUtils";
import moment from "moment/moment";
import {CrPdfConfig} from "../utils/pdfUtils";
import {decrypt} from "../../../utils/crypto";
const _ = require("lodash");

export const returnButton = {
    type: 'return',
    tKey: 'return',
    bsStyle: 'default'
}

export const saveButton = {
    type: 'save',
    tKey: 'save',
    bsStyle: 'success'
}

export const validateButton = {
    action: 'validate',
    bsStyle: 'primary',
    tKey: 'validate',
    type: 'action'
}

export const reviseButton = {
    action: 'revise',
    bsStyle: 'warning',
    tKey: 'réviser',
    type: 'action'
}

export const refuseButton = {
    action: 'refuse',
    bsStyle: 'danger',
    tKey: 'refuse',
    type: 'action'
}

export const delegateButton = {
    action: 'delegate',
    bsStyle: 'warning',
    tKey: 'déléguer',
    type: 'action'
}

export const abandonButton = {
    action: 'abandon',
    bsStyle: 'danger',
    tKey: 'abondonner',
    type: 'action'
}
export const arbitrateButton = {
    action: 'arbitrate',
    bsStyle: 'warning',
    tKey: 'demander arbitrage',
    type: 'action'
}
export const sendButton = {
    action: 'send',
    bsStyle: 'primary',
    tKey: 'envoyer le compte-rendu',
    type: 'action'
}

export const draftButton = {
    action: 'save',
    bsStyle: 'success',
    tKey: 'brouillon',
    type: 'action'
}

export const transmitButton = {
    action: 'transmit',
    bsStyle: 'primary',
    tKey: 'valider',
    type: 'action'
}
export const validateDemandeurButton = {
    action: 'validate',
    bsStyle: 'success',
    tKey: 'enregistrer',
    type: 'action'
}
export const warnAndValidateButton = {
    action: 'arbitrate',
    bsStyle: 'primary',
    tKey: 'valider avec réserve',
    type: 'action'
}

export const buttonsIfArbitrator = [validateButton, refuseButton, abandonButton, returnButton]
export const buttonsIfDraft= [draftButton, validateDemandeurButton, transmitButton, returnButton]
export const buttonsIfFirstDemander= [saveButton, validateButton, abandonButton, returnButton] //buttonsIfFirstContributor
export const steps = [
    {
        name: "preValidation",
        buttons: [saveButton, validateButton, reviseButton, refuseButton, abandonButton, returnButton]
    },
    {
        name: "demand",
        buttons: [saveButton, validateButton, reviseButton, abandonButton, returnButton],
    },
    {
        name: "control",
        buttons: [validateButton, reviseButton, returnButton],
    },
    {
        name: "validation",
        buttons: [validateButton, reviseButton, refuseButton, abandonButton, returnButton],
    },
    {
        name: "realization",
        buttons: [saveButton, validateButton, abandonButton, returnButton],
    }
]

export function userHaveExhaustifScope (userHabs){
    for (let i = 0; i < userHabs.length; i++) {
        if ( !userHabs[i].grantedAccess.length && !userHabs[i].grantedMesh.length ){
            return true
        }
    }
    return false
}

export function generateOrderOfSteps (steps, workFlowConfigs) {
    let orderOfSteps = {}
    let c= 1
    steps.forEach( step => {
        for (let i = 0; i < workFlowConfigs.length; i++) {
            if (workFlowConfigs[i].step===step.name){
                orderOfSteps[step.name] = c
                c+=1
                break
            }
        }
    })
    return orderOfSteps
}

export function generateMaxOrder (workFlowConfigs) {
    let maxOrder = {}
    workFlowConfigs.forEach( config => {
        if (!maxOrder[config.step]) {
            maxOrder[config.step] = config.order
        }
        else if ( config.order > maxOrder[config.step] ){
            maxOrder[config.step] = config.order
        }
    })
    return maxOrder
}

export function getPreviousStepPreviousOrder(currentStep, currentOrder, workFlowConfigs){
    const maxOrderByStep = generateMaxOrder(workFlowConfigs)                  // {"step": order, ...}
    const orderOfSteps = generateOrderOfSteps(steps, workFlowConfigs)   //{"step": classement}

    if (currentStep === null) return [null, null]
    if (orderOfSteps[currentStep] === 1 && currentOrder === 1) return [null, null]
    if ( maxOrderByStep[currentStep] > 1 && currentOrder > 1 ){
        return [currentStep, currentOrder-1]
    }
    if (currentOrder === 1){
        const x = Object.keys(orderOfSteps)
        const previousStep = x[orderOfSteps[currentStep]-2]
        if (previousStep === 'preValidation' ){
            return [previousStep, 1]
        }
        else {
            return [previousStep, maxOrderByStep[previousStep]]
        }
    }
}

export function getAndValidateNextStep(currentStep, currentOrder, workflowConfigs, alreadyTreatedByFunctions){
    const maxOrderByStep = generateMaxOrder(workflowConfigs)                  // {"step":order, ...}
    const orderOfSteps = generateOrderOfSteps(steps, workflowConfigs)   //{"step":classement}
    let [nextStep, nextOrder] = [null, null]

    if (currentStep === 'approved'){return ['approved',1000000]}
    else if ( currentStep === 'closed') {return ['closed',1000000]}
    else if ( currentStep === 'abandoned') {return ['abandoned',1000000]}
    else if ( currentStep === 'draft') {
        const firstStep = Object.keys(orderOfSteps)[0]
        return [firstStep,1]
    }
    if (maxOrderByStep[currentStep]){
        for ( let i = 1; i <= maxOrderByStep[currentStep]; i++){
            const thisOrderConfigs = workflowConfigs.filter(conf => conf.step === currentStep && conf.order === i)
            const thisOrderRolesIDs = thisOrderConfigs.map(conf => new global.ObjectID(conf.role.id).toString() )
            if ( !alreadyTreatedByFunctions[currentStep] || !alreadyTreatedByFunctions[currentStep].flat(1).some( roleID => thisOrderRolesIDs.includes(roleID) ) ){
                [nextStep, nextOrder] = [currentStep, i]
                break
            }
        }
    }

    if ( !nextStep || !nextOrder ){
        nextStep = Object.keys(orderOfSteps)[orderOfSteps[currentStep]]
        nextOrder = 1
        if ( !!nextStep && !!nextOrder){
            return [nextStep, nextOrder]
        }
        else if ( currentStep === 'validation') {return ['approved',1000000]}
        else if ( currentStep === 'realization') {return ['closed',1000000]}
    }
    else {
        return [nextStep, nextOrder]
    }
}

export function transmitToNextStep( workflowConfigs ){
    const maxOrderByStep = generateMaxOrder(workflowConfigs)            // {"step":order, ...}
    const orderOfSteps = generateOrderOfSteps(steps, workflowConfigs)   //{"step":classement}
    let [nextStep, nextOrder] = [null, null]
    const firstStep = Object.keys(orderOfSteps)[0]
    if ( maxOrderByStep[firstStep] > 1 ){
        return [firstStep, 2]
    }
    else {
        nextStep = Object.keys(orderOfSteps)[orderOfSteps[firstStep]]
        return [nextStep, 1]
    }
}

export function getNextStepStatus(nextStep) {
    if (nextStep==='demand'){
        return {id:'10'}
    } else if (nextStep==='control'){
        return {id:'2'}
    } else if (nextStep==='validation'){
        return {id:'3'}
    } else if (nextStep==='approved'){
        return {id:'6'}
    } else if (nextStep==='realization'){
        return {id:'7'}
    } else if (nextStep==='closed'){
        return {id:'8'}
    } else if (nextStep==='preValidation'){
        return {id:'12'}
    }
}

export function isItFirstStepFirstOrder(module, step, order){
    const firstStep = order === 1 && ( (module === 'preValidation' && step === 'preValidation') || (module === 'DemandInstruction' && step === 'demand') )
    if ( firstStep ) return true

    return false
}
export function isItDraft(step, order){
    if (step === "draft" && order === 1){
        return true
    }
    return false
}


export function getUserHabsAndGrantedOrgsAndMeshesPerRole(context, callback) {
    global.app.SE.Habilitation.find({
        ...basicContext(context),
        fieldPath: ["role.id", "grantedAccess", "grantedMesh"],
        query: { user: new global.ObjectID(context.user.id) }
    }, (e, userHabilitations) => {
        if(e) return callback(e)
        if(!userHabilitations.length) return callback(e, [])

        let userGrantedOrgsAndMeshes = []
        userHabilitations.forEach( hab => {
            userGrantedOrgsAndMeshes.push(hab.grantedAccess)
            userGrantedOrgsAndMeshes.push(hab.grantedMesh)
        })
        const userGrantedOrgsAndMeshesIDs = userGrantedOrgsAndMeshes.flat(1)

        if (!userGrantedOrgsAndMeshesIDs.length) return callback(null, userHabilitations, {})

        global.app.SE.OrganizationalMesh.find(
            {
                ...basicContext(context),
                fieldPath: [],
                query: {
                    $or: [
                        { "attachments": {$elemMatch : {$in : userGrantedOrgsAndMeshesIDs.map( org => new global.ObjectID(org.id)) }} },
                        { _id: {$in : userGrantedOrgsAndMeshesIDs.map( org => new global.ObjectID(org.id)) }}
                    ]
                }
            }, (er, meshes) => {
                if(er) return callback(er)
                let userGrantedOrgsAndMeshesPerRole = {}
                userHabilitations.forEach( hab => {
                    let orgsAndMeshes = []
                    orgsAndMeshes.push(hab.grantedAccess)
                    orgsAndMeshes.push(hab.grantedMesh)
                    userGrantedOrgsAndMeshesPerRole[hab.role.id] = orgsAndMeshes.flat(1).map(org => org.id)
                })
                if ( !!meshes.length ){
                    meshes.forEach( mesh => {
                        Object.keys(userGrantedOrgsAndMeshesPerRole).forEach( role => {
                            if ( userGrantedOrgsAndMeshesPerRole[role].includes(mesh.id) ) {
                                userGrantedOrgsAndMeshesPerRole[role].push(mesh.id)
                                mesh.attachments.forEach( att => userGrantedOrgsAndMeshesPerRole[role].push(att.toString()) )
                            }
                            else if ( mesh.attachments.some( orgId => userGrantedOrgsAndMeshesPerRole[role].includes(orgId.toString())) ){
                                userGrantedOrgsAndMeshesPerRole[role].push(mesh.id)
                                mesh.attachments.forEach( att => userGrantedOrgsAndMeshesPerRole[role].push(att.toString()) )
                            }
                        })
                    })
                }

                return callback(null, userHabilitations, userGrantedOrgsAndMeshesPerRole)
            })
    })

}

export function updateRevisedTables(newObject, oldObject) {
    const isTotalLine = obj => obj.objet === 'Tot.' && obj.entity === null && obj.imputationType === null;

    const processTable = (newTable, oldTable, shouldProcessLines) => {
        if (!newTable || !oldTable) return [];
        const filteredNewTable = newTable.filter(line => !isTotalLine(line));

        if (shouldProcessLines) {
            filteredNewTable.forEach(line => {
                const oldLine = oldTable.find(row => row.id.toString() === line.id.toString());
                if (oldLine) {
                    Object.assign(line, {
                        budget: oldLine.budget,
                        validated: oldLine.validated,
                        estimated: oldLine.estimated,
                        validatedEngagement: oldLine.validatedEngagement,
                        ongoingFiscalYearValidatedEngagement: oldLine.ongoingFiscalYearValidatedEngagement,
                        // ongoingFiscalYearValidatedBudget ??????
                        ongoingFiscalYearValidatedBudget: oldLine.ongoingFiscalYearBudget,
                        ongoingFiscalYearValidated: oldLine.ongoingFiscalYearValidated,
                        ongoingFiscalYearEstimated: oldLine.ongoingFiscalYearEstimated,
                    });
                }
            })
        }

        const newTableIds = new Set(filteredNewTable.map(line => line.id.toString()));
        const untouchedOldLines = oldTable.filter(line => !newTableIds.has(line.id.toString()));
        return [...filteredNewTable, ...untouchedOldLines];
    };

    newObject.revisedTable = processTable(newObject.revisedTable, oldObject.revisedTable, true);
    newObject.revisedTableHistory = processTable(newObject.revisedTableHistory, oldObject.revisedTableHistory, false);
}

export async function sendCommitteeReport(newObject, context, options) {
    const { recipients, otherRecipients, filesArray, subjectTemplate, contentHtml, revueDate } = options;

    if (!recipients || !recipients.length) {
        throw new Errors.ValidationError('You have to select at least one recipient');
    }

    const currency = await global.app.SE.Currency.collection.findOne({ nature: '1' });
    if (!currency) {
        throw new Errors.ValidationError('You have to create a reference currency first');
    }

    const file = await new Promise((resolve, reject) => {
        global.pdf.generatePdf(CrPdfConfig(context.module.name, newObject, context, currency), (error, file) => {
            if (error) return reject(error);
            resolve(file);
        });
    });

    filesArray.push({
        user: _.pick(context.user, ['id', 'name']),
        date: moment().format("YYYY-MM-DD HH:mm"),
        ...file
    });

    const subject = { template: subjectTemplate(moment.utc(revueDate, 'YYYY-MM-DD').format('DD-MM-YYYY'), newObject.demandNumber) };

    const createMail = (to) => ({
        from: 'support@keenpoint.com',
        to,
        subject,
        content: { html: contentHtml },
        attachments: [file],
        verbose: { general: true }
    });

    const mails = recipients.map(user => createMail(decrypt(user.mail)));

    if (otherRecipients && otherRecipients.length) {
        otherRecipients.split(';').map(str => str.trim()).forEach(mail => {
            mails.push(createMail(mail));
        });
    }

    await new Promise((resolve, reject) => {
        global.mailer.sendMail(mails, (error) => {
            if (error) return reject(error);
            resolve();
        });
    });
}

export function _updateRevisedTableHistory(newObject) {
    newObject.revisedTableHistory = newObject.revisedTable.map( line => { return {...line, id: new global.ObjectID()}} );
}

export function _updateCompleteRevisedTableHistory(newObject){
    newObject.revisedTable.forEach( line => {
        newObject.completeRevisedTableHistory.push({
            ...line,
            id: new global.ObjectID(),
            revueDate: moment().format("YYYY-MM-DD HH:mm:ss"), // instead of newObject.revueDate, //to have in the history the exact time when it was saved
            meetingsPlanning: newObject.meetingsPlanning,
        });
    });
}

export async function sendMails(mails) {
    if (!mails || mails.length === 0) {
        return;
    }
    return new Promise((resolve, reject) => {
        global.mailer.sendMail(mails, (error) => (error ? reject(error) : resolve()));
    });
}

export async function findFiscalYearsForMonth(context, month) {
    const targetDate = moment().format('YYYY-MM') === month ? moment().toDate() : moment(month, 'YYYY-MM').toDate();
    const query = {
        'fiscalYearRange.0': { $lte: targetDate },
        'fiscalYearRange.1': { $gte: targetDate },
    };
    const fiscalYears = await global.app.SE.FiscalYear.find({
        ...basicContext(context),
        fieldPath: [],
        query,
    });

    if (!fiscalYears.length) {
        throw new Errors.ValidationError("Aucun exercice n'a été configuré pour le mois que vous avez choisi");
    }
    if (fiscalYears.length > 1) {
        throw new Errors.ValidationError("Erreur lors de l'identification de l'exercice de la demande");
    }

    return fiscalYears[0];
}

export async function findAndValidateWorkflowConf(context, newObject) {
    const workflowConfs = await global.app.SE.WorkFlow.find({
        ...basicContext(context),
        fieldPath: ['workFlowConfigs.step', 'workFlowConfigs.order', 'workFlowConfigs.role.id'],
        query: {
            organizationAndMesh: { $elemMatch: { $eq: new global.ObjectID(newObject.organizationAndMesh.id) } },
            demandCategory: { $eq: new global.ObjectID(newObject.demandCategory.id) },
            demandNature: { $elemMatch: { $eq: new global.ObjectID(newObject.demandNature.id) } },
            minMaxAmount: new global.ObjectID(newObject.plafond.id),
        },
    });

    if (!workflowConfs.length) {
        throw new Errors.ValidationError('your demand have no defined workflow');
    }
    if (workflowConfs.length !== 1) {
        throw new Errors.ValidationError('your demand have more than one workflow');
    }
    return workflowConfs[0];
}

//Gets all related organizations and meshes for a given organization.
export async function getDemandAugmentedOrgs(context, orgAndMeshId) {
    const orgId = new global.ObjectID(orgAndMeshId);
    const meshes = await global.app.SE.OrganizationalMesh.find({
        ...basicContext(context),
        fieldPath: [],
        query: { $or: [{ attachments: { $elemMatch: { $eq: orgId } } }, { _id: { $eq: orgId } }] },
    });

    if (!meshes.length) return [orgId];

    const augmentedOrgs = new Set();
    meshes.forEach((mesh) => {
        augmentedOrgs.add(new global.ObjectID(mesh.id).toString());
        mesh.attachments.forEach((att) => augmentedOrgs.add(new global.ObjectID(att).toString()));
    });

    return Array.from(augmentedOrgs).map((id) => new global.ObjectID(id));
}

export async function getGrantedOrgsAndMeshesPerRole(context, habilitations) {
    if (!habilitations || !habilitations.length) {
        return {};
    }

    const grantedOrgsAndMeshes = habilitations.flatMap((h) => [...(h.grantedAccess || []), ...(h.grantedMesh || [])]);

    if (grantedOrgsAndMeshes.length === 0) {
        if (!userHaveExhaustifScope(habilitations)) {
            throw new Errors.ValidationError('Vous ne disposez pas des autorisations nécessaires pour accomplir cette action');
        }
        return {}; //if exhaustif, we verify Habs directly
    }

    const grantedOrgsAndMeshesIds = grantedOrgsAndMeshes.map((o) => new global.ObjectID(o.id));
    const meshes = await global.app.SE.OrganizationalMesh.find({
        ...basicContext(context),
        fieldPath: [],
        query: {$or: [
                {attachments: { $elemMatch: { $in: grantedOrgsAndMeshesIds } } },
                { _id: { $in: grantedOrgsAndMeshesIds } }
            ]},
    });

    const orgsByRole = {}; // {rodeId: Set(orgId,...)}
    for (const hab of habilitations) {
        const orgs = [...(hab.grantedAccess || []), ...(hab.grantedMesh || [])].map((o) => o.id.toString());
        orgsByRole[hab.role.id] = new Set(orgs);
    }

    for (const mesh of meshes) {
        const meshIdStr = mesh.id.toString();
        const attachmentIdsStr = mesh.attachments.map((att) => att.toString());
        for (const roleId in orgsByRole) {
            const roleOrgs = orgsByRole[roleId];
            const isRelated = roleOrgs.has(meshIdStr) || attachmentIdsStr.some((attId) => roleOrgs.has(attId));
            if (isRelated) {
                roleOrgs.add(meshIdStr);
                attachmentIdsStr.forEach((id) => roleOrgs.add(id));
            }
        }
    }

    const finalOrgsByRole = {};  // {rodeId: [orgId,...]
    for (const roleId in orgsByRole) {
        finalOrgsByRole[roleId] = Array.from(orgsByRole[roleId]);
    }

    return finalOrgsByRole;
}

export async function findHabilitatedUsersForNextStep(context, roleIDs, orgIDs = []) {
    const orgObjectIDs = orgIDs.map((id) => new global.ObjectID(id));
    return global.app.SE.Habilitation.find({
        ...basicContext(context),
        fieldPath: ['user.id'],
        query: {
            role: { $in: roleIDs.map((id) => new global.ObjectID(id)) },
            $or: [
                { grantedAccess: [], grantedMesh: [] },
                { grantedAccess: { $elemMatch: { $in: orgObjectIDs } }, grantedMesh: [] },
                { grantedAccess: [], grantedMesh: { $elemMatch: { $in: orgObjectIDs } } },
            ],
        },
    });
}

export async function prepareWorkflowData(newObject, context) {
    // looking for the workflow for this demand
    const _workflowConf = await findAndValidateWorkflowConf(context, newObject);

    //Gets the first step of the workflow
    const orderOfSteps = generateOrderOfSteps(steps, _workflowConf.workFlowConfigs);
    const firstStep = Object.keys(orderOfSteps)[0];
    let firstRolesIDs = _workflowConf.workFlowConfigs.filter(conf => conf.step === firstStep && conf.order === 1).map(conf => conf.role.id);

    //Gets all related organizations and meshes to the demande organization.
    const demandAugmentedOrgsAndMeshesIDs = ["save", "delegate"].includes(context.action)
        ? undefined
        : await getDemandAugmentedOrgs(context, newObject.organizationAndMesh.id);

    //preparing readers
    const readersIDs = _workflowConf.readers.map(role => new global.ObjectID(role.id));
    const readers = await findHabilitatedUsersForNextStep(context, readersIDs, demandAugmentedOrgsAndMeshesIDs);

    //looking for related Projects or Demands
    const principalProjectOrDemandId = context?.module?.category?.path === 'Projet' ? newObject.relatedProject?.id : newObject.relatedDemand?.id;
    const queryForRelatedProjectsOrDemands = !!principalProjectOrDemandId ?
        context?.module?.category?.path === 'Projet' ?
            {relatedProject: new global.ObjectID(principalProjectOrDemandId)}
            : {relatedDemand: new global.ObjectID(principalProjectOrDemandId)}
        : {_id: null};
    const relatedProjectsOrDemands = await global.app.SE.Demand.find({
        ...basicContext(context),
        fieldPath: [],
        query: queryForRelatedProjectsOrDemands
    });

    //looking for demand Start and End FiscalYears
    const [demandStartFiscalYear, demandEndFiscalYear] = await Promise.all([
        findFiscalYearsForMonth(context, newObject.startMonth),
        findFiscalYearsForMonth(context, newObject.endMonth),
    ]);

    // looking for the habilitation of this user,
    const userHabilitations = await global.app.SE.Habilitation.find({
        ...basicContext(context),
        fieldPath: ["role.id", "grantedAccess", "grantedMesh"],
        query: {user: new global.ObjectID(context.user.id)}
    });

    // looking for user habilitations with the current roles to intervene in the demand
    let userGrantedOrgsAndMeshesPerRole;
    if (context.module && context.module.name === "arbitration") {
        userGrantedOrgsAndMeshesPerRole = {};
    } else {
        const currentConfigs = !!newObject.workflow && !!newObject.workflow[0] && newObject.workflow[0] !== 'draft' ?
            _workflowConf.workFlowConfigs.filter(conf => conf.step === newObject.workflow[0] && conf.order === parseInt(newObject.workflow[1]))
            : _workflowConf.workFlowConfigs.filter(conf => conf.step === firstStep && conf.order === 1);
        const currentRolesIDs = currentConfigs.map(conf => new global.ObjectID(conf.role.id));
        const userHabilitationsForCurrentRoles = await global.app.SE.Habilitation.find({
            ...basicContext(context),
            fieldPath: ["role.id", "grantedAccess", "grantedMesh"],
            query: {
                user: new global.ObjectID(context.user.id),
                role: {$in: currentRolesIDs}
            }
        });
        userGrantedOrgsAndMeshesPerRole = await getGrantedOrgsAndMeshesPerRole(context, userHabilitationsForCurrentRoles);
    }

    // looking for user habilitations for arbitration
    let arbitratorGrantedOrgsAndMeshesPerRole;
    if (context.module && context.module.name !== "arbitration") {
        arbitratorGrantedOrgsAndMeshesPerRole = {};
    } else {
        arbitratorGrantedOrgsAndMeshesPerRole = await getGrantedOrgsAndMeshesPerRole(context, userHabilitations);
    }

    const userIsInDelegateTo = (newObject.delegateTo && newObject.delegateTo.map(user => user.id).includes(context.user.id));
    const userIsInCurrentContributors = (newObject.currentContributors && newObject.currentContributors.map(user => user.id).includes(context.user.id));

    if (!userHabilitations.length && !userIsInDelegateTo) {
        throw new Errors.ValidationError('Vous ne disposez pas des autorisations nécessaires pour accomplir cette action');
    }

    return { _workflowConf, firstStep, firstRolesIDs, demandAugmentedOrgsAndMeshesIDs, readersIDs, readers, relatedProjectsOrDemands, demandStartFiscalYear, demandEndFiscalYear, userHabilitations, userGrantedOrgsAndMeshesPerRole, arbitratorGrantedOrgsAndMeshesPerRole };
}

export function _demandNumberHelper(newObject, relatedProjectsOrDemands, context) {
    const firstLetter = context.module.name === 'preValidation' ? 'P' : 'D';
    const isPrincipalProjectOrDemand = context?.module?.category?.path === 'Projet' && !newObject.relatedProject || context?.module?.category?.path === 'demande' && !newObject.relatedDemand;
    const principalProjectOrDemandNumber = context?.module?.category?.path === 'Projet' ? newObject.relatedProject?.demandNumber : newObject.relatedDemand?.demandNumber;

    return isPrincipalProjectOrDemand ?
        firstLetter + '-' + newObject.startFiscalYear.code + '-' + newObject.organizationAndMesh.code + '-' + newObject.demandNature.code + '-' + newObject.sequence
        : principalProjectOrDemandNumber + '-' + parseInt(relatedProjectsOrDemands.length + 1);
}

export function _addAutomaticComment(newObject, context, commentText) {
    newObject.comments.push({
        automatic: true,
        user: _.pick(context.user, ['id', 'name']),
        text: commentText,
        date: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
}

export function _initializeAlreadyTreatedByFunctions (newObject, firstStep = null, currentStep = null) {
    if (!newObject.alreadyTreatedByFunctions) newObject.alreadyTreatedByFunctions = {};
    if (!!firstStep && !newObject.alreadyTreatedByFunctions[firstStep]){
        newObject.alreadyTreatedByFunctions[firstStep] = [];
    }
    if (!!currentStep && !newObject.alreadyTreatedByFunctions[currentStep]){
        newObject.alreadyTreatedByFunctions[currentStep] = [];
    }
}